export function formatRemoveDecimals(value) {
  if (value === null || value === undefined || value === "") return "";

  const str = String(value).replace(",", ".").trim();
  const num = Number(str);

  if (!Number.isFinite(num)) return str;

  // Remove trailing zeros and dangling decimal point
  return str.includes(".")
    ? str.replace(/(\.\d*?[1-9])0+$/, "$1").replace(/\.0+$/, "")
    : String(num);
}


/**
 * Normalise a code/enum field value.
 * Trims whitespace and converts to uppercase.
 * Returns '' if the value is null or undefined.
 *
 * Usage:
 *   onChange={(e) => handleChange('userType', toCode(e.target.value))}
 */
export const toUpper = (value) => {
  if (value == null) return '';
  return String(value).trim().toUpperCase();
};



/**
 * Normalise a username / login identifier.
 * Trims whitespace and converts to lowercase.
 * Usernames are identifiers, not display codes — lowercase is the standard.
 */
export const toLower = (value) => {
  if (value == null) return '';
  return String(value).trim().toLowerCase();
};
